import { useModal } from 'components/Modal/hooks';
import { Modal } from 'components/Topic/Following.Modal';

export const useTopicFollowingModal = () => {
  return useModal(Modal, {
    keepMounted: false,
  });
};